<template>
  <div>
    <article>
      <section class="xbed-sub-title">
        <span>基础数据管理</span>
      </section>

      <section class="xbed-breadcrumb">
        <Breadcrumb>
          <BreadcrumbItem>城市中心仓管理</BreadcrumbItem>
        </Breadcrumb>
      </section>
    </article>

    <Form :model="centerManageForm" :label-width="80" inline class="form-style">
      <FormItem label="省份">
        <Select style="width:120px" v-model="centerManageForm.province" @on-change="changeCenterProvince">
          <Option :value="-1">全部</Option>
          <Option v-for="item in centerProvinces" :key="item.provinceId" :value="item.provinceId">{{item.province}}</Option>
        </Select>
      </FormItem>
      <FormItem label="城市">
        <Select v-model="centerManageForm.city" style="width:120px" filterable>
          <Option :value="-1">全部</Option>
          <Option v-for="item in centerCityList" :key="item.cityId" :value="item.cityId">{{item.city}}</Option>
        </Select>
      </FormItem>
      <FormItem label="联系电话">
        <Input v-model="centerManageForm.phone" placeholder="请输入联系电话"></Input>
      </FormItem>
      <FormItem label="状态">
        <Select v-model="centerManageForm.status" style="width:120px">
          <Option :value="-1">全部</Option>
          <Option :value="0">停用</Option>
          <Option :value="1">启用</Option>
        </Select>
      </FormItem>
      <FormItem :label-width="80">
        <Button type="primary" @click="queryCenterListWithKeyword">查询</Button>
      </FormItem>
      <FormItem :label-width="20">
        <Button type="primary" @click="openEditCenterHouse">新建中心仓</Button>
      </FormItem>
    </Form>
    <Table stripe :columns="columns" :data="centerList"></Table>
    <div style="margin: 10px;overflow: hidden">
        <Page show-sizer placement="top" :total="listCount" :current="listPage" @on-page-size-change="changePageSize" @on-change="changePage"></Page>
    </div>
    <!-- 新建/编辑中心仓弹窗 -->
    <Modal v-model="editCenterHousemodal.display" ref="editCenterHousemodal" :title="editCenterHousemodal.id ? '编辑中心仓':'新建中心仓'" :loading="true" @on-ok="asyncOK" :ok-text="editCenterHousemodal.id?'保存':'确认新建'">
      <Form :label-width="80" class="form-style" :model="editCenterHousemodal" ref="editCenterHousemodalForm" :rules="editCenterHousemodal.rules">
        <FormItem label="ID" prop="id" v-if="editCenterHousemodal.id">
          <span>{{editCenterHousemodal.id}}</span>
        </FormItem>
        <FormItem label="仓库名称" prop="repositoryName">
          <Input v-model="editCenterHousemodal.repositoryName" placeholder="请输入仓库名称" :maxlength="30"></Input>
        </FormItem>
        <FormItem label="成品仓id" prop="finalfRepositoryId">
          <Input v-model="editCenterHousemodal.finalfRepositoryId" placeholder="请输入成品仓id" :maxlength="30"></Input>
        </FormItem>
        <FormItem label="流通仓id" prop="circulateRepositoryId">
          <Input v-model="editCenterHousemodal.circulateRepositoryId" placeholder="请输入流通仓id" :maxlength="30"></Input>
        </FormItem>
        <!-- <FormItem label="房间仓id" prop="roomRepositoryId">
          <Input v-model="editCenterHousemodal.roomRepositoryId" placeholder="请输入房间仓id" :maxlength="30"></Input>
        </FormItem> -->
        <FormItem label="管家仓id" prop="cleanerRepositoryId">
          <Input v-model="editCenterHousemodal.cleanerRepositoryId" placeholder="请输入管家仓id" :maxlength="30"></Input>
        </FormItem>
        <FormItem label="仓库地址">
          <Row>
                <Col span="8">
                   <FormItem prop="provinceId" class="modal-select-style">
                    <Select v-model="editCenterHousemodal.provinceId" ref="province" @on-change="changeProvice" filterable class="address-select-style">
                      <Option v-for="item in privoicesList" :value="item.id" :key="item.id">{{item.custName }}</Option>
                    </Select>
                    <span>省</span>
                    </FormItem>
                </Col>
                <Col span="8">
                    <FormItem prop="cityId" class="modal-select-style">
                      <Select v-model="editCenterHousemodal.cityId" ref="city" @on-change="changeCity" filterable class="address-select-style">
                        <Option v-for="item in cityList" :value="item.id" :key="item.id">{{ item.custName }}</Option>
                      </Select>
                      <span>市</span>
                    </FormItem>
                </Col>
                <Col span="8">
                  <FormItem prop="districtId" class="modal-select-style">
                      <Select v-model="editCenterHousemodal.districtId" ref="district" filterable class="address-select-style">
                        <Option v-for="item in districtList" :value="item.id" :key="item.id">{{ item.custName }}</Option>
                      </Select>
                      <span>区</span>
                  </FormItem>
                </Col>
            </Row>
        </FormItem>
      <FormItem prop="stressAddress">
        <Input v-model="editCenterHousemodal.stressAddress" placeholder="请输入仓库详细地址" :maxlength="100"></Input>
      </FormItem>
      <FormItem label="经度" prop="longitude">
        <Input v-model="editCenterHousemodal.longitude" placeholder="请输入经度"></Input>
      </FormItem>
      <FormItem label="纬度" prop="latitude">
        <Input v-model="editCenterHousemodal.latitude" placeholder="请输入纬度"></Input>
          <div class="text-container">
            <p class="text-left-style">*坐标值范围：经度+-180，纬度+-90</p>
            <a href="https://lbs.amap.com/console/show/picker" target="_blank" class="text-right-style">获取高德坐标</a>
          </div>
      </FormItem>
      <FormItem label="联系电话" prop="phone">
        <Input v-model="editCenterHousemodal.phone" placeholder="请输入联系电话"></Input>
      </FormItem>
      <FormItem label="状态">
        <Select v-model="editCenterHousemodal.status" class="address-select-style">
          <Option :value="1">启用</Option>
          <Option :value="0">停用</Option>
        </Select>
      </FormItem>
      </Form>
    </Modal>
    <!-- 关联城市弹窗 -->
    <Modal v-model="associatedCityModal.display" ref="associatedCityModal" title="关联城市" @on-ok='associatedCity' :loading="true">
      <Form>
        <FormItem label="名称" :label-width="80">
         <Input v-model="associatedCityModal.cityCenterWarehouse" disabled style="width: 300px"></Input>
       </FormItem>
       <FormItem label="关联城市" :label-width="80">
         <Select v-model="associatedCityModal.associatedCityId" style="width:400px" multiple placeholder="请选择关联城市" label-in-value @on-change="associatedChangeCity" filterable>
            <Option v-for="item in associatedCityModal.associatedcityList" :key="item.id" :value="item.id">{{item.custName}}</Option>
         </Select>
       </FormItem>
       <Table :columns="countyDistrict" :data="associatedCityModal.countyDistrictData" @on-selection-change="selectChange"></Table>
      </Form>
    </Modal>
  </div>
</template>
<script>
import Utils from "../../utils";
import API from "../../api";

import { phoneRegular, LngAndLatRegExp } from "@/utils/regular.js";
export default {
  created() {
    this.token = Utils.findFromLocalStorage("vue-token");
    this.username = Utils.findFromLocalStorage("vue-username");
    this.env = Utils.findFromLocalStorage("env", "dev");
    this.$nextTick(async () => {
      await this.queryCenterList();
      this.queryCenterCityList();
    });
  },
  mounted(){
    this.queryProvincesList()
    this.centerProvinceList()
    this.$Notice.config({
      top: 200
    });
  },
  data() {
    const editCenterHousemodalRules = {
      repositoryName: (rule, value, callback) => {
        if (this.editCenterHousemodal.repositoryName.length === 0) {
          return callback(new Error("仓库名称不能为空"));
        }
        callback();
      },
      provinceId: (rule, value, callback) => {
        if (!this.editCenterHousemodal.provinceId) {
          return callback(new Error("省不能为空"));
        }
        callback();
      },
      cityId: (rule, value, callback) => {
        if (!this.editCenterHousemodal.cityId) {
          return callback(new Error("城市不能为空"));
        }
        callback();
      },
      // districtId: (rule, value, callback) => {
      //   if (!this.editCenterHousemodal.districtId) {
      //     return callback(new Error("区域不能为空"));
      //   }
      //   callback();
      // },
      stressAddress: (rule, value, callback) => {
        if (this.editCenterHousemodal.stressAddress.length === 0) {
          return callback(new Error("详细地址不能为空"));
        }
        callback();
      },
      latitude: (rule, value, callback) => {
        if (!LngAndLatRegExp.test(this.editCenterHousemodal.latitude)) {
          return callback(new Error("请输入正确的伟度"));
        }
        callback();
      },
      longitude: (rule, value, callback) => {
        if (!LngAndLatRegExp.test(this.editCenterHousemodal.longitude)) {
          return callback(new Error("请输入正确的经度"));
        }
        callback();
      },
      phone: (rule, value, callback) => {
        if (
          !phoneRegular.test(this.editCenterHousemodal.phone) ||
          this.editCenterHousemodal.phone.length === 0
        ) {
          return callback(new Error("请填写正确的联系电话"));
        }
        callback();
      }
    };
    return {
      respData:[],
      cityLength:[],
      listCount: 0,
      listPage: 1,
      centerManageForm: {
        page: 1,
        size: 10,
        city: -1,
        province: -1,
        phone:'',
        status: -1
      },
      sendCenterManageForm: {
        page: 1,
        size: 10,
        city: -1,
        province: -1,
        phone:'',
        status: -1
      },
      columns: [
        {
          title: "ID",
          key: "id",
          align: "center",
          width: 100,
        },
        {
          title: "名称",
          key: "repositoryName",
          align: "center",
          width: 120,
        },
        {
          title: "成品仓id",
          key: "finalfRepositoryId",
          align: "center",
          width: 100,
        },
        {
          title: "流通仓id",
          key: "circulateRepositoryId",
          align: "center",
          width: 100,
        },
        // {
        //   title: "房间仓id",
        //   key: "roomRepositoryId",
        //   align: "center"
        // },
        {
          title: "管家仓id",
          key: "cleanerRepositoryId",
          align: "center",
          width: 100,
        },
        {
          title: "省市",
          key: "province",
          align: "center",
          width: 100,
        },
        {
          title: "城市",
          key: "city",
          align: "center",
          width: 100,
        },
        {
          title: "行政区",
          key: "district",
          align: "center",
          width: 120,
        },
        {
          title: "街道地址",
          key: "stressAddress",
          align: "center",
          width: 150,
        },
        {
          title: "经纬度",
          align: "center",
          width: 200,
          render: (h, params) => {
            return (
              "div",
              [
                h("p", {}, `经度: ${params.row.longitude}`),
                h("p", {}, `纬度: ${params.row.latitude}`)
              ]
            );
          }
        },
        {
          title: "联系电话",
          key: "phone",
          align: "center",
          width: 150,
        },
        {
          title: "关联区域",
          key: "districtListString",
          align: "center",
          width: 150,
        },
        {
          title: "状态",
          key: "status",
          align: "center",
          width: 100,
          render: (h, params) => {
            return "span", {}, params.row.status === 1 ? "启用" : "停用";
          }
        },
        {
          title: "操作",
          key: "action",
          align: "center",
          width: 150,
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small"
                  },
                  style:{
                   margin:'5px'
                  },
                  on: {
                    click: () => {
                      this.openEditCenterHouse({
                        id: params.row.id,
                        repositoryName: params.row.repositoryName,
                        provinceId: params.row.provinceId,
                        cityId: params.row.cityId,
                        districtId: params.row.districtId,
                        stressAddress: params.row.stressAddress,
                        latitude: params.row.latitude,
                        longitude: params.row.longitude,
                        phone: params.row.phone,
                        status: params.row.status,
                        finalfRepositoryId: params.row.finalfRepositoryId,
                        circulateRepositoryId: params.row.circulateRepositoryId,
                        // roomRepositoryId: params.row.roomRepositoryId,
                        cleanerRepositoryId: params.row.cleanerRepositoryId
                      });
                    }
                  }
                },
                "编辑"
              ),
              h('Button',{
                props:{
                  type:'primary',
                  size:'small'
                },
                on:{
                  click:()=>{
                    this.clickAssociatedCityModal(params.row);
                  }
                }
              },'关联城市')
            ]);
          }
        }
      ],
      centerCityList: [], // 城市列表
      centerList: [],
      privoicesList: [],
      cityList: [],
      districtList: [],
      // 弹窗声明
      editCenterHousemodal: {
        id: "",
        display: false,
        repositoryName: "",
        provinceId: "",
        finalfRepositoryId: "",
        circulateRepositoryId: "",
        // roomRepositoryId: "",
        cleanerRepositoryId: "",
        cityId: "",
        districtId: "",
        stressAddress: "",
        latitude: "",
        longitude: "",
        phone: null,
        status: 1,
        rules: {
          repositoryName: [
            {
              required: true,
              trigger: "blur",
              validator: editCenterHousemodalRules.repositoryName
            }
          ],
          provinceId: [
            {
              required: true,
              trigger: "change",
              validator: editCenterHousemodalRules.provinceId
            }
          ],
          cityId: [
            {
              required: true,
              trigger: "change",
              validator: editCenterHousemodalRules.cityId
            }
          ],
          // districtId: [
          //   {
          //     required: true,
          //     trigger: "change",
          //     validator: editCenterHousemodalRules.districtId
          //   }
          // ],
          stressAddress: [
            {
              required: true,
              trigger: "blur",
              validator: editCenterHousemodalRules.stressAddress
            }
          ],
          latitude: [
            {
              required: true,
              trigger: "blur",
              validator: editCenterHousemodalRules.latitude
            }
          ],
          longitude: [
            {
              required: true,
              trigger: "blur",
              validator: editCenterHousemodalRules.longitude
            }
          ],
          phone: [
            {
              required: true,
              trigger: "blur",
              validator: editCenterHousemodalRules.phone
            }
          ]
        }
      },
      // 关联城市弹窗
      associatedCityModal:{
        display:false,
        associatedCityId:[],
        associatedcityList:[],
        cityCenterWarehouse:'',
        countyDistrictData:[],
        associatedCountyId:'',
        chooseCity:[],
        queryCityData:{}
      },
      countyDistrict:[
        {
          type: 'selection',
          width: 80,
          align: 'center'
        },
        {
          title:'ID',
          key:'id',
          align:'center',
          width:135
        },
        {
          title:'关联区域',
          key:'custName',
          align:'center',
          width:135
        },
        {
          title:'关联城市',
          key:'LinkCityName',
          align:'center',
          width:135
        },
      ],
    };
  },
  methods:{
    async queryCenterList(){
     let centerList = (await API.omsAPI[this.env].cleaner.centerManagementList(this.sendCenterManageForm,this.token)).data 
     this.listCount = centerList.totalCount 
     this.centerList = centerList.content || []
    },  
    async queryCenterCityList(params = {}){
     let centerCityList = (await API.omsAPI[this.env].cleaner.centerCityList(params,this.token)).data  
     this.centerCityList = centerCityList || []
    },
    // async queryCenterCityList() {
    //   let centerCityList = (await API.omsAPI[this.env].cleaner.centerCityList(
    //     this.sendCenterManageForm,
    //     this.token
    //   )).data;
    //   this.centerCityList = centerCityList || [];
    // },
    async queryProvincesList() {
      //获取省份列表
      let ProvincesList = (await API.omsAPI[this.env].common.queryProvinces())
        .data;
      this.privoicesList = ProvincesList.province || [];
    },
    async centerProvinceList() {
      this.centerProvinces = (await API.omsAPI[this.env].cleaner.centerProvinceList({}, this.token)).data
    },
    changeCenterProvince(provinceId) {
      provinceId === -1 && (provinceId = '')
      this.queryCenterCityList({ provinceId })
    },
    async changeProvice (id) {
      let resp = (await API.omsAPI[this.env].common.queryCities(id)).data
      this.cityList = resp.city
    },
    async changeCity(id) {
      if (!id) {
        this.editCenterHousemodal.districtId = null;
      }
      let resp = (await API.omsAPI[this.env].common.queryCounties(id)).data;
      this.districtList = resp.county;
    },
    changePageSize(pageSize) {
      this.sendCenterManageForm.size = pageSize;
      this.queryCenterList();
    },
    changePage(pageIndex) {
      this.listPage = pageIndex;
      this.sendCenterManageForm.page = pageIndex;
      this.queryCenterList();
    },
    queryCenterListWithKeyword() {
      this.sendCenterManageForm = Object.assign({}, this.centerManageForm);
      this.queryCenterList();
    },
    openEditCenterHouse(editCenterHousemodal = {}) {
      this.$refs.editCenterHousemodalForm.resetFields();
      this.editCenterHousemodal = Object.assign(
        this.editCenterHousemodal,
        {
          display: true,
          id: "",
          repositoryName: "",
          finalfRepositoryId: "",
          circulateRepositoryId: "",
          // roomRepositoryId: "",
          cleanerRepositoryId: "",
          provinceId: "",
          cityId: "",
          districtId: "",
          stressAddress: "",
          latitude: "",
          longitude: "",
          phone: null,
          status: 1
        },
        editCenterHousemodal
      );
    },
    async asyncOK() {
      let validResult = false;
      this.$refs.editCenterHousemodalForm.validate(valid => {
        validResult = valid;
      });
      if (!validResult) {
        this.$refs.editCenterHousemodal.buttonLoading = false;
        return;
      }
      let resp = null;
      let params = {
        city: this.$refs.city.query,
        cityId: this.editCenterHousemodal.cityId,
        createName: this.username,
        district: this.$refs.district.query,
        districtId: this.editCenterHousemodal.districtId,
        latitude: this.editCenterHousemodal.latitude,
        longitude: this.editCenterHousemodal.longitude,
        phone: this.editCenterHousemodal.phone,
        province: this.$refs.province.query,
        provinceId: this.editCenterHousemodal.provinceId,
        repositoryName: this.editCenterHousemodal.repositoryName,
        status: this.editCenterHousemodal.status,
        finalfRepositoryId:  this.editCenterHousemodal.finalfRepositoryId == null ? '' : this.editCenterHousemodal.finalfRepositoryId,
        circulateRepositoryId: this.editCenterHousemodal.circulateRepositoryId == null ? '':this.editCenterHousemodal.circulateRepositoryId,
        // roomRepositoryId: this.editCenterHousemodal.roomRepositoryId,
        cleanerRepositoryId: this.editCenterHousemodal.cleanerRepositoryId == null ? '' : this.editCenterHousemodal.cleanerRepositoryId,
        stressAddress: this.editCenterHousemodal.stressAddress
      };
      if (this.editCenterHousemodal.id) {
        params.id = this.editCenterHousemodal.id;
        params.updateName = this.username;
        resp = (await API.omsAPI[this.env].cleaner.editCenterManagement(
          params,
          this.token
        )).data;
      } else {
        params.createName = this.username;
        resp = (await API.omsAPI[this.env].cleaner.addCenterManagement(
          params,
          this.token
        )).data;
      }
      if (resp.retCode) {
        this.$refs.editCenterHousemodal.buttonLoading = false;
        this.$Notice.error({
          title: `${this.editCenterHousemodal.id ? "编辑" : "新增"}失败`,
          desc: resp.msg,
          top: 25
        });
      } else {
        this.$Notice.success({
          title: `${this.editCenterHousemodal.id ? "编辑" : "新增"}成功`,
          desc: resp.msg,
          top: 25
        });
        this.editCenterHousemodal.display = false;
        this.queryCenterList();
      }
    },
    // 关联区域
    async clickAssociatedCityModal(datas){
      if (!Utils.hasPermission('oms_admin_xbCenterRepository_addDistrict')) {
        this.$Notice.error({
          title: "无权限操作"
        });
        return
      }
      this.respData = []; 
      this.cityLength = [];
      this.associatedCityModal.associatedCityId = [];
      this.associatedCityModal.queryCityData = datas;
      this.associatedCityModal.cityCenterWarehouse = datas.repositoryName;
      let id = datas.provinceId
      let resp = (await API.omsAPI[this.env].common.queryCities(id)).data;
      this.associatedCityModal.associatedcityList = resp.city;
      this.associatedCityModal.countyDistrictData = [];
      this.associatedCityModal.display = true;
    },
    async associatedChangeCity(cityValue){
      if (this.cityLength.length > cityValue.length) {
        let index = 0
        if (cityValue.length !== 0) {
          for(let i = 0; i < this.cityLength.length; i++ ) {
            if(cityValue[i]&&(cityValue[i].value-0 !== this.cityLength[i].value-0)){
              index = i; 
              break;
            }else{
              index = i;
            }
          }
        }
        this.cityLength.splice (index,1);
        this.respData.splice (index,1);
        this.showCityData()
        return '';

      }
      if (!cityValue || cityValue.length === 0) {
        return;
      }
      let queryId; //父级的id
      let queryName; //父级的城市名字
      cityValue.forEach(city=>{
         queryId = city.value;
         queryName = city.label;
       })
      let resp = (await API.omsAPI[this.env].common.queryCounties(queryId)).data;
      let cityName = JSON.parse(JSON.stringify(resp.county));
      cityName.forEach(item=>{  // 显示父级城市
        if(item.parentId == queryId){
          item.LinkCityName = queryName
        }
      })
      this.respData.push(cityName);
      this.showCityData()
      this.cityLength = cityValue || [];
    },
    // 区县数据拼接
    showCityData(){
      this.associatedCityModal.countyDistrictData = [];
      this.respData.map((item)=>{
        this.associatedCityModal.countyDistrictData = this.associatedCityModal.countyDistrictData.concat(item);
      }) 
    },
    selectChange(list){
      this.associatedCityModal.chooseCity = list;
    },
    async associatedCity(){
      if (this.cityLength.length == 0) {
        this.$Notice.error({
            title:'关联城市',
            desc: '请先选择关联城市',
        });
        this.$refs.associatedCityModal.buttonLoading = false;
        return;
      }
      if (this.associatedCityModal.countyDistrictData.length !== 0) {
        if (this.associatedCityModal.chooseCity.length == 0) {
          this.$Notice.error({
            title:'关联区域',
            desc: '请选择关联区域',
          });
          this.$refs.associatedCityModal.buttonLoading = false;
          return;
        }
      }
      const counties = this.associatedCityModal.chooseCity;
      const paramsCounties = [];
      counties.forEach(county =>{
        paramsCounties.push({
          countyId:county.id,
          countyName:county.custName,
        })
      })
      let params = {
        repositoryId:this.associatedCityModal.queryCityData.id,
        provinceId:this.associatedCityModal.queryCityData.provinceId,
        province:this.associatedCityModal.queryCityData.province,
        createName:this.username,
        counties:JSON.stringify(paramsCounties)
      }
      let resp = (await API.omsAPI[this.env].cleaner.postAddDistrict(params,this.token)).data;
       if(resp.retCode) {
        this.$Notice.error({
          title: '关联城市',
          desc: resp.msg
        })
        this.$refs.associatedCityModal.buttonLoading = false;
        return
      }
      this.$Notice.success({
        title:'关联城市',
        desc: '操作成功',
      });
      this.queryCenterList();
      this.associatedCityModal.display = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.form-style {
  margin-top: 20px;
}
.address-select-style {
  width: 100px;
}
.text-container {
  display: flex;
  .text-left-style {
    color: red;
    flex: 4;
  }
  .text-right-style {
    flex: 1;
  }
}
</style>

  



// WEBPACK FOOTER //
// src/pages/basic-data-management/center-management.vue